<template>
  <div class="filter">
    <div class="row">
      <div class="small-3 columns">
        <div class="search-box">
          <label class="field-label">Search:</label>
          <div class="search">
            <div class="search-input-box">
              <input type="text" v-model="searchInput" ref="search" :disabled="loading"
                v-on:keypress.enter="search" v-on:blur="blurSearch" />
                <transition name="slide-left">
                  <i class="far fa-times-circle fa-lg" @click="clearSearch"
                    v-if="searchInput.length > 0"></i>
                </transition>
            </div>
            <button :class="{'button xsmall success':true, 'disabled':loading}"
              @click="search">
              <i class="fas fa-search fa-lg"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="small-2 columns end small-offset-6">
        <div class="status last">
          <label class="field-label">&nbsp;</label>
          <div class="flex">
            <select v-model="status" :disabled="loading">
              <option value="activate">Activate</option>
              <option value="deactivate">Deactivate</option>
            </select>
            <button :class="{'button small':true, 'disabled':loading}" @click="updateStatus">Go</button>
          </div>
        </div>
      </div>

      <div class="small-1 columns end">
        <div class="export-box">
          <button :class="{'button cta success large block':true, 'disabled':exportLoading}" @click="exportCons">
            <span v-if="exportLoading">Loading...</span>
            <span v-else>EXPORT</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiConsumerList from '@/modules/api/consumer/list'
import CsvExport from 'csvexport'

const exporter = CsvExport.create({
  filename: 'export.csv',
  columns: [
    'First Name', 'Last Name', 'Email', 'Mobile',
    'Created Date', 'Referral Code', 'Status', 'Stripe Link'
  ]
})

export default {
  name: 'list-filter',
  data () {
    return {
      searchInput: '',
      blurDelay: '',
      exportLoading: false
    }
  },
  // components: {Picker},
  computed: {
    brands () { return this.$store.state.brands.list },
    loading () { return this.$store.state.consumer.users.isLoading },
    status: {
      get () { return this.$store.state.consumer.selectedStatus },
      set (value) { this.$store.commit('consumer/setSelectedStatus', value) }
    },
  },
  methods: {
    refreshTable () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('consumer/setUserIsLoading', true)
      self.$store.commit('consumer/resetUsers')
      self.$store.commit('consumer/setUserCurrentPage', 1)

      ApiConsumerList.getList(self, res => {
        self.$store.commit('consumer/setUserIsLoading', false)
      })
    },
    search () {
      this.$store.commit('consumer/setUserSearch', this.searchInput)
      this.refreshTable()
    },
    blurSearch () {
      let self = this
      if (self.$store.state.consumer.users.search === self.searchInput.trim()) {
        return
      }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    clearSearch () {
      if (this.blurDelay) { clearTimeout(this.blurDelay) }
      if (this.loading) { return }

      this.searchInput = ''
      this.$store.commit('consumer/setUserSearch', this.searchInput)
      this.refreshTable()
    },
    updateStatus () { this.$store.commit('consumer/setTriggerStatusUpdate', true) },
    exportCons () {
      let self = this
      if (self.exportLoading) { return }

      self.exportLoading = true
      ApiConsumerList.export(self, res => {
        self.exportLoading = false
        if (!res.error) {
          exporter.downloadCsv(res)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter{
  border-bottom:1px solid #bbb;
  background: #fcfcfc;
  margin-bottom: 10px;
  border-radius: 2px;

  .row{ max-width: 100%; }
}

.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}

.search-box{
  display: inline-block;
  padding: 20px 0 20px 15px;
  position: relative;
  width: 100%;

  .error-msg{
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 15px);
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    margin-left: 15px;
    background: #ff6115;
    color: #fff;
    transform-origin: bottom center;
  }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 5px 0 0 5px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 0;
      right: 5px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
    padding: 0 20px;
  }
}

.status{
  display: inline-block;
  padding: 20px 0 20px 15px;
  width: 100%;

  &.last{ padding-right: 10px; }
}

select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}

.flex{
  display: flex;

  select{
    flex-grow: 100;
  }
}

.export-box{ padding: 35px 10px 0; }

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .small-3 {
    width: 100%;
  }

  .small-2, .small-1 {
    width: 50%;
  }

  .small-offset-6 {
    margin-left: 0;
  }

  .search-box, .status, .export-box {
    padding: 0 10px;
  }

  .search-box {
    padding-top: 5px;
  }

  .export-box {
    margin-top: 15px;
    padding-bottom: 15px;
    .large {
      line-height: 16px;
      font-size: 16px;
      padding: 12px 17px 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/ListFilter.vue